<template>
  <div class="zv-page">
    <div class="zv-content">
      <div class="zv-block">
         <zv-table :table="table" ref="dataTable">
          <div slot="ctrl-button">
            <el-button type="primary" @click="doAdd()">新增字段</el-button>
          </div>
        </zv-table>
    <zv-dialog
      width="400px"
      :title="isEdit ? '修改' : '新增'"
      :showDialog.sync="showFormDialog"
      @close-dialog="closeFormDialog"
    >
      <div slot="content">
        <el-form
          ref="myForm"
          label-width="100px"
          :model="formData"
          :rules="formRules"
          status-icon
        >
          <el-form-item label="字段名称：" prop="title">
            <el-input v-model="formData.title" clearable></el-input>
          </el-form-item>
          <el-form-item label="内容来源：" prop="field_id">
             <el-select
                class="el-input-width1"
                v-model="formData.field_id"
                filterable
              >
                <el-option
                  v-for="item in fieldList"
                  :key="item.field_id"
                  :label="item.field_name"
                  :value="item.field_id"
                >
                </el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="启用状态：" prop="status">
            <el-switch
              v-model="formData.status"
              :active-value="1"
              :inactive-color="0">
            </el-switch>
          </el-form-item>
        </el-form>
      </div>
      <div slot="btns">
        <el-button @click="showFormDialog = false">取消</el-button>
        <el-button type="primary" @click="submitForm">确定</el-button>
      </div>
    </zv-dialog>
  </div>
   </div>
  </div>
</template>

<script>
import api from "./api";
import addFormMixin from "@/mixins/addFormMixin";
import tokenService from "@/utils/services/token_service";
export default {
  name: "expertDatabase",
  mixins: [addFormMixin],
  data() {
    let vm = this;
    return {
      addressSelectData: null,
      addressItem: null,
      name: "",
      currentPage: 1,
      totalList: null,
       table: {
        api: api.fieldConfigList,
        hidePagination: true,
        query: {
          syndication_config_id: vm.$route.query.id
        },
        searchData: [
          {
            type: "input",
            model: "syndication_field_config_id",
            placeholder: "字段id"
          },
          {
            type: "input",
            model: "title",
            placeholder: "字段名称"
          }
        ],
        columns: [
          {
            title: "字段名称",
            key: "title",
            minWidth:"100",
          },
          {
            title: "内容来源字段",
            key: "field_name",
            minWidth:"100",
            showTooltip: true
          },
          {
            title: "创建时间",
            key: "add_time",
            minWidth:"150",
            showTooltip: true,
            render(h, ctx) {
              return h("span", vm.$commFunc.formatDate(ctx.row.add_time));
            }
          },
          {
            title: "操作人",
            key: "last_admin_username",
            minWidth: "90",
            render(h, ctx) {
              let status = ctx.row.last_admin_username;
              let statusText;
              if (status == "") {
                statusText = "--";
              } else {
                statusText = status;
              }
              return h("span", statusText);
            }
          },
          {
            title: "启用状态",
            minWidth: "80",
            render(h, ctx) {
              const statusBtn = h("el-switch", {
                attrs: {
                  value: ctx.row.status,
                  "inactive-value": 0,
                  "active-value": 1
                },
                on: {
                  change(status) {
                    vm.doChangeStatus(status, ctx.row.id);
                  }
                }
              });

              return h("span", [statusBtn]);
            }
          },
          {
            title: "操作",
            fixed: "right",
            minWidth:"150",
            render(h, ctx) {
              const editBtn = h(
                "el-button",
                {
                  attrs: {
                    type: "text"
                  },
                  on: {
                    click: vm.doEdit.bind(this, ctx.row)
                  }
                },
                "修改"
              );

              const delBtn = h(
                "el-button",
                {
                  attrs: {
                    type: "text"
                  },
                  on: {
                    click: vm.doDelete.bind(this, ctx.row.id)
                  }
                },

                "删除"

              );

              let arr = [];
              arr.push(editBtn);
              return h("span", arr);
            }
          }
        ]
      },
      adddApi: api.syndicationConfigFieldAdd,
      editApi: api.syndicationConfigFieldEdit,
      addSuccessMsg: '添加成功',
      editSuccessMsg: '编辑成功',
      deleteSuccessMsg: '删除成功',
      formDataOri: {
        syndication_config_id: vm.$route.query.id
      },
      formRules: {
        field_name: [{
          required: true,
          message: "字段名称不能为空",
          trigger: "blur"
        }],
        field_id: [{
          required: true,
          message: "内容来源不能为空",
          trigger: "change"
        }]
      }
    };
  },
  created() {
    this.fieldListFn()
    // this.getData();
  },
  methods: {
    // 内容来源下拉菜单
    fieldListFn() {
      let datas = {
        article_category_id: this.$route.query.category_id
      }
      api
        .syndicationConfigFieldList(datas)
        .then(res => {
          this.fieldList = res.field
        })
        .catch(err => {});
    },
    // 查询参数
    // queryData() {
    //   let data = {
    //     name: this.name
    //   };
    //   if (data.name) {
    //     this.getData(data);
    //   } else {
    //     this.getData();
    //   }
    // },

    // 新增数据
    doAddExtra() {
      // this.formRules = Object.assign({}, this.formRulesOri, this.pwdRule)
      // this.formRules.syndication_config_id = this.$route.query.id
      // console.log(this.formData)
    },


    // 删除数据
    deleteData(row) {
      let data = {
        id: row.id
      };
      this.$confirm("确定删除该条记录？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.delete(data);
        })
        .catch(() => {});
    },

    delete(data) {
      api
        .recordedDelete(data)
        .then(res => {
          this.$message({
            message: "删除成功！",
            type: "success"
          });
          this.getData();
        })
        .catch(err => {});
    },

    //改变每页显示数量重新请求数据，重置当前页为第一页
    handleSizeChange(val) {
      let pageSize = { pagesize: val };
      this.getData(pageSize);
    },

    //点击改变当前页
    handleCurrentChange(val) {
      let page = { page: val };
      this.getData(page);
    }
  }
};
</script>

<style lang="scss" scoped>
.pagination {
  text-align: right;
  padding: 0 20px;
}
.countryName {
  margin-right: 10px;
  width: 40px;
  justify-content: center;
  align-items: center;
  display: flex;
}
</style>